<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "../../router/index.js";
import {listServiceLocation} from "@/api/serviceLocation/serviceLocation.js";

/*初次加载*/
onMounted(() => {
  handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  locationName: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listServiceLocation(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.locationName = null
  formData.phone = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  {title: '名称', key: 'locationName', width: "120px", nowrap: true},
  {title: '类型', key: 'locationType', width: "150px", nowrap: true},
  {title: '联系地址', key: 'address', width: "250px", nowrap: true},
  {title: '联系电话', key: 'phone', width: "150px", nowrap: true},
  {title: '营业时间', key: 'operatingHoursChineseAndEnglish', width: "150px", nowrap: true},
  {title: '操作', key: 'controls', width: "100px", fixed: true},
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 添加服务地点
const handleAdd = () => {
  router.push({ path: 'editServiceLocation' })
}

/*操作栏功能*/
// 编辑
const getDetail = async (info) => {
  router.push({path: "editServiceLocation", query: {locationId: info.locationId}})
}

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">新建服务地点
      </v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="9">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.locationName"
                        placeholder="请输入服务地点名"
                        label="服务地点名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" offset="6">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索
                        </v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset">重置
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.locationType="{item}">
            <div v-if="item.locationType === 'HOTEL'">酒店</div>
            <div v-else>未知</div>
          </template>

          <template v-slot:item.address="{ item }">
            {{item.province}}{{item.city}}{{item.district}}{{item.addressDetail}}
          </template>

          <template v-slot:item.operatingHoursChineseAndEnglish="{ item }">
            <div v-if="item.operatingHours.length <= 0">
              -
            </div>
            <div v-else>
              <div v-for="(hour, hourIndex) in item.operatingHoursChineseAndEnglish" :key="`operatingHours${hourIndex}`">
                {{hour.weekdayOpen}} 至 {{hour.weekdayClose}} {{hour.operatingStart}} - {{hour.operatingEnd}}
              </div>
            </div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left flex_align_b">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="top">
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-file-edit-outline" size="small" color="primary" @click="getDetail(item)"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :page-size="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>
